import template from './searchInput.html';
import controller from './searchInput.controller';
import './searchInput.scss';

let searchInputComponent = {
  restrict: 'E',
  bindings: {
    search: '&',
    type: '@'
  },
  template,
  controller
};

export default searchInputComponent;
